import { useEffect } from 'react';
import { Outlet } from '@tanstack/react-router';
import { MeResponseSchema } from '@web/shared';
import { apiRequest } from '@/lib/api';
import { getToken, updateSessionUser } from '@/lib/session';
import { AppAura } from '@/components/ui/app-aura';
import { applyFlavorTheme, readStoredFlavorTheme } from '@/features/profile/flavor-theme';

/**
 * Root element. Revalidates the stored session against the API once on load so
 * a revoked/expired token is caught and role/onboard changes propagate.
 */
export function RootBoot() {
  useEffect(() => {
    // Belt-and-suspenders: theme-init.js already applied this pre-paint.
    const f = readStoredFlavorTheme();
    if (f) applyFlavorTheme(f, false);
  }, []);

  useEffect(() => {
    if (!getToken()) return;
    apiRequest('/api/auth/me', { schema: MeResponseSchema })
      .then((res) => updateSessionUser(res.user))
      .catch(() => {
        /* api.ts already clears the session on 401 */
      });
  }, []);

  return (
    <>
      <AppAura />
      <Outlet />
    </>
  );
}
